import { useAuthStore } from "core/stores/authStore";

const guestGuard = () => {
  const isAuthenticated = useAuthStore.getState().checkSession();
  return !isAuthenticated;
};

export default guestGuard;
